<template>
  <div>
    <b-container>
      <div v-if="(!isSessionDetailComponent && !isSessionItemDetailItemComponet) && isLoaded" class="wrap-school-of-creativity">
        <h1>{{ symposiumStageTitle }}</h1>
        <div v-for="(day, dayIndex) in sectionData2" :key="'day' + dayIndex">
          <h2 v-if="!day.image" class="title"><span>{{ day.title }}</span></h2>
          <div v-else> <img loading="lazy" :src="day.image" class="image" :alt="day.title"></div>
          <b-row class="section">
            <b-col v-for="section in day.data" :key="'section' + section.id" cols="6" md="4" lg="4" class="content"
              @click="clickStage(section)">
              <img loading="lazy" :src="section.imgUrl" />
              <p v-if="section.description">{{ section.description }}</p>
            </b-col>
          </b-row>
        </div>
        <p class="note" v-if="symposiumStageNote">{{ symposiumStageNote }}</p>
      </div>
    </b-container>
    <SymposiumStageDetail v-if="isSessionDetailComponent" />
    <SymposiumSessionDetail v-if="isSessionItemDetailItemComponet" />
  </div>

</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'
import { getBaseMetaCurrentYear } from '@/environments'

const SymposiumStageDetail = () =>
  import('@/components/Creativity/SymposiumStageDetail')

const SymposiumSessionDetail = () => import('@/components/Creativity/SymposiumSessionDetail')

export default {
  components: {
    SymposiumStageDetail,
    SymposiumSessionDetail
  },

  data () {
    return {
      isLoaded: false,
      baseCurrentYear: getBaseMetaCurrentYear,
      sectionData: [],
      sessionId: 1,
      sessionData: [],
      sectionData2: [
        {
          title: '15 NOV',
          data: []
        },
        {
          title: '16 NOV',
          data: []
        }
      ]
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      schoolCreativesRaw: (state) => state.creativity.schoolCreatives
    }),

    isSessionDetailComponent () {
      if (this.$route.name === 'SymposiumStageDetail') {
        return true
      } else {
        return false
      }
    },
    isSessionItemDetailItemComponet () {
      if (this.$route.name === 'SymposiumSessionDetail') {
        return true
      } else {
        return false
      }
    },
    symposiumStageTitle () {
      const mConfig = this.configMap.get('symposiumStageTitle')
      return mConfig ? mConfig.isDisplay ? mConfig.name : '' : 'Adman Awards & Symposium 2025 All Stage'
    },
    symposiumStageNote () {
      const mConfig = this.configMap.get('symposiumStageNote')
      return mConfig ? mConfig.isDisplay ? mConfig.name : '' : 'The schedule and speakers may be subject to change as appropriate.'
    }
  },

  methods: {
    mapSection (data) {
      this.sectionData = []
      this.sectionData2[0].data = []
      this.sectionData2[1].data = []

      const stageDay1 = this.configMap.get('symposiumStageDay1')
      this.sectionData2[0].image = stageDay1?.isDisplay ? stageDay1?.image : null
      this.sectionData2[0].title = stageDay1?.isDisplay && stageDay1.name ? stageDay1.name : this.sectionData2[0].title

      const stageDay2 = this.configMap.get('symposiumStageDay2')
      this.sectionData2[1].image = stageDay2?.isDisplay ? stageDay2?.image : null
      this.sectionData2[1].title = stageDay2?.isDisplay && stageDay2.name ? stageDay2?.name : this.sectionData2[1].title

      data.forEach((schoolCreative) => {
        const obj = {
          id: schoolCreative.id,
          imgUrl: `${this.baseURL}/storage/app/img/creativeDay/${schoolCreative.image}`,
          description: schoolCreative.description,
          detail: schoolCreative.detail
        }

        // custom day
        // schoolCreative.id for day
        const day1 = [1, 2, 3, 4, 5]
        const day2 = [6, 7, 8, 9, 10]

        // mapSection day 1
        if (day1.includes(schoolCreative.id)) {
          this.sectionData2[0].data.push(obj)
        }

        // mapSection day 2
        if (day2.includes(schoolCreative.id)) {
          this.sectionData2[1].data.push(obj)
        }

        this.sectionData.push(obj)
      })

      this.isLoaded = true
    },

    mapSession (id, data) {
      this.sessionData = []

      if (data) {
        data.forEach((schoolCreative) => {
          if (id === schoolCreative.id) {
            schoolCreative.detail.forEach((detail) => {
              this.sessionData.push(detail)
            })
          }
        })
      }
    },

    clickStage (stage) {
      this.$router.push({
        name: 'SymposiumStageDetail',
        params: {
          mainId: stage.id
        }
      })
    },

    clickDetail () {
      this.mapDetail(this.schoolCreativesRaw)
    }
  },

  watch: {
    schoolCreativesRaw (data) {
      if (data) {
        this.mapSection(data)
      }
    },

    sectionData (data) {
      if (data) {
        this.mapSession(this.sessionId, this.schoolCreativesRaw)
      }
    },

    schoolCreativeDetail (data) {
      this.mapDetail(data)
    }
  },

  created () {
    this.$store.dispatch('creativity/getSchoolCreativity')
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.wrap-school-of-creativity {
  padding-bottom: 22px;

  h1 {
    padding: 22px 0;
    text-align: center;
    color: #212529;
    font-family: var(--h3-font-family, "DB HelvethaicaMon X");
    font-size: var(--h3-font-size, 48px);
    font-style: normal;
    font-weight: var(--h3-font-weight, 500);
    line-height: normal;
  }

  h2 {
    padding: 22px 0;
    line-height: 1;
  }

  .image {
    width: 100%;
    margin-bottom: 16px;
  }

  .title {
    display: flex;
    align-items: center;
    width: 100%;
    color: #DA0401;
    text-align: center;
    font-family: var(--h2-font-family, "DB HelvethaicaMon X");
    font-size: var(--h2-font-size, 60px);
    font-style: normal;
    font-weight: var(--h2-font-weight, 700);
    line-height: normal;
  }

  .title::before,
  .title::after {
    content: "";
    flex: 1;
    border-bottom: 8px solid #DA0401;
  }

  .title::before {
    margin-right: 0.25em;
  }

  .title::after {
    margin-left: 0.25em;
  }

  .note {
    text-align: center;
    color: var(--baseColor-neutral-1000, #000);
    font-family: var(--h4-font-family, "DB HelvethaicaMon X");
    font-size: var(--h4-font-size, 18px);
    font-style: normal;
    font-weight: var(--h4-font-weight, 500);
    line-height: normal;
  }

  .section {
    margin-bottom: 22px;
    flex-wrap: wrap;

    .content {
      cursor: pointer;
      padding-top: 12px;
      padding-bottom: 12px;

      img {
        width: 100%;
        height: auto;
        background-color: $light;
      }

      p {
        padding: 22px 0;
        line-height: 1;
        font-size: 1.25rem;
      }
    }
  }

  hr {
    margin: 44px 0;
    width: 100%;
    border: 0.25px solid #ccc;

    @media only screen and (min-width: $break-m) {
      margin: 62px 0;
    }
  }

  .session {
    a {
      margin-bottom: 12px;
      width: 100%;

      .time {
        padding-top: 8px;
        padding-bottom: 8px;
        background-color: $light;

        h3 {
          align-items: center;
          line-height: 1;
          font-size: 1.25rem;
          color: black;
        }

        .personal {
          margin-top: 6px;
          width: auto;
          display: flex;
          justify-content: flex-start;

          .text {
            margin-right: 22px;
            padding-left: 22px;
            border-left: 1px solid #ccc;

            p {
              margin-bottom: -8px;
            }

            p:last-child {
              margin-bottom: 0px;
              color: $dark;
            }
          }

          .text:first-child {
            padding-left: 0;
            border-left: none;
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    h1 {
      font-size: 60px;
      font-size: var(--h3-font-size, 24px);
    }

    .title {
      font-size: var(--h2-font-size, 32px);
    }

    .note {
      font-size: var(--h4-font-size, 18px);
      text-align: left;
    }
  }
}
</style>
